import { LINKS } from "../../config/links";

const PILLARS = [
  {
    num: "01",
    title: "Automated Follow-Up",
    copy: "SMS + email sequences that keep every lead warm — without you lifting a finger.",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M3 8l9 6 9-6M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    num: "02",
    title: "Instant Lead Response",
    copy: "Leads get a reply in seconds — not hours. The 5-minute window stays unbroken.",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" />
      </svg>
    ),
  },
  {
    num: "03",
    title: "Appointment Reminders",
    copy: "Confirmation + 1-day + 1-hour reminders that quietly destroy no-shows.",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 8v4l3 2M12 2a10 10 0 100 20 10 10 0 000-20z" />
      </svg>
    ),
  },
  {
    num: "04",
    title: "Lead Nurturing",
    copy: "30-day nurture + re-engagement flows turn cold leads into future revenue.",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
      </svg>
    ),
  },
];

export default function Solution() {
  return (
    <section
      id="solution"
      data-testid="solution-section"
      className="relative py-24 sm:py-32 border-y border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="max-w-3xl mb-16">
          <div className="reveal flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-amber-500/70" />
            <span className="font-sans-body uppercase text-[11px] tracking-[0.32em] text-amber-400">
              The Solution
            </span>
          </div>
          <h2
            data-testid="solution-headline"
            className="reveal font-display font-light text-white text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-[-0.01em] text-balance"
            style={{ transitionDelay: "80ms" }}
          >
            A simple system that turns leads into{" "}
            <span className="italic text-amber-400">booked appointments.</span>
          </h2>
          <p
            className="reveal mt-5 text-slate-300 text-base sm:text-lg leading-relaxed"
            style={{ transitionDelay: "140ms" }}
          >
            Four moving parts. Built once. Running forever.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PILLARS.map((p, i) => (
            <div
              key={p.num}
              data-testid={`solution-pillar-${p.num}`}
              className="reveal group bg-[#0e1e44]/70 border border-white/10 hover:border-amber-500/40 p-7 transition-all duration-400 hover:-translate-y-1"
              style={{ transitionDelay: `${120 + i * 80}ms` }}
            >
              <div className="flex items-center justify-between mb-8">
                <div className="h-11 w-11 border border-amber-500/40 bg-amber-500/10 text-amber-400 flex items-center justify-center">
                  {p.icon}
                </div>
                <span className="font-display text-2xl text-slate-500">{p.num}</span>
              </div>

              <h3 className="font-display text-2xl text-white leading-tight">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">
                {p.copy}
              </p>
            </div>
          ))}
        </div>

        {/* Mid-CTA */}
        <div className="reveal mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-white/10 pt-10">
          <p className="font-display text-xl sm:text-2xl text-white max-w-lg leading-tight">
            Want to see exactly how this runs inside your business?
          </p>
          <a
            href={LINKS.calendar}
            data-testid="solution-cta"
            className="group inline-flex items-center gap-3 bg-amber-600 hover:bg-amber-500 text-slate-950 font-semibold px-8 py-4 text-[13px] uppercase tracking-[0.18em] transition-all duration-300 hover:-translate-y-0.5 shrink-0"
          >
            Show Me How It Works
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="transition-transform group-hover:translate-x-1">
              <path d="M5 12h14M13 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
